module.exports = __webpack_public_path__ + "static/assets/1ce3c89082491ed51d9d29e82ac27542.svg";